// اضافه کردن کتابخانه ها به صفحه
import * as React from "react";
import {Close, KeyboardArrowLeft, KeyboardArrowRight, Payment} from "@mui/icons-material";
import {useTranslation} from "react-i18next";

// ایمپورت کردن کامپوننت ها در داخل صفحه
import Sender from "./sender";
import InfoBox from "./infoBox";
import {useSnackbar} from "notistack";
import {Box, CircularProgress} from "@mui/material";
import Invoice from "../multiOrder/invoice";
import {useDispatch, useSelector} from "react-redux";
import {setLoading} from "../../redux/loading/actions.js";
import {setListBox} from "../../redux/multiOrder/infoBox/actions";
import NavBar from "../../components/NavBar";
import {createSearchParams, Link, useLocation, useNavigate, useSearchParams} from "react-router-dom";
import {checkNonZeroPrefix, handleScrollIntoView, useShowMessageComponent} from "../../assets/js/main";
import HandleFetchData from "../../plugin/HandleFetchData";
import {setListReview} from "../../redux/singleOrder/review/actions";


export default function MultiOrder() {
    // استفاده از متود های i18n برای چند زبان کردن پروژه و تغییر زبان پروژه
    const {t} = useTranslation();
    const {enqueueSnackbar} = useSnackbar();
    const {fetchData} = HandleFetchData()
    const {showMessageComponent} = useShowMessageComponent()
    const location = useLocation();
    const dispatch = useDispatch();
    const selector = useSelector((st) => st)
    const navigate = useNavigate();
    const servicesRefSender = React.useRef()
    const firstNameRefSender = React.useRef()
    const lastNameRefSender = React.useRef()
    const mobileRefSender = React.useRef()
    const postalCodeRefSender = React.useRef()
    const addressRefSender = React.useRef()
    const address1RefSender = React.useRef()
    const paymentRefMethods = React.useRef()

    const [searchParams] = useSearchParams();
    const divarIncomId = searchParams.get('state')

    // متغیر و useState های لوکال صفحه
    const [step, setStep] = React.useState(0)
    const [validationShow, setValidationShow] = React.useState({});
    const [validate, setValidate] = React.useState(false);

    //--------------Invoices----------------
    const [items_Invoices, setItems_Invoices] = React.useState(null);
    const [paymentMethod, setPaymentMethod] = React.useState(null);
    const [discountCode, setDiscountCode] = React.useState(null);

    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, [step]);

    // متد رفتن به مرحله بعدی
    function nextStep() {
        step !== 0 && setStep(step + 1)
        setValidationShow(null)

        selector?.multi_info_box?.excelList?.length ?
            handlerAddFormWithExcel()
            :
            handlerAddForm()

    }

    // متد برگشت به مرحله قبل
    function preStep() {
        setStep(step - 1)
        setValidationShow(null)
        dispatch(setListBox([]))
    }

    // متد انصراف از سفغارش
    function cancelStep() {
        setStep(0)
        setValidationShow(null)
        dispatch(setListBox([]))

    }

    const validationsInfoSender = () => {
        window.scrollTo(0, 0);

        if (!selector?.multi_sender?.address) {
            validationMethod(addressRefSender, 'address_validation_Sender', t("error.t8"))
        } else if (selector?.multi_sender?.address.length < 5) {
            validationMethod(addressRefSender, 'address_validation_Sender', t("error.t9"))
        } else if (selector?.multi_sender?.address.length > 180) {
            validationMethod(addressRefSender, 'address_validation_Sender', t("error.t10"))
        } else if (!selector?.multi_sender?.lat || !selector?.multi_sender?.lng) {
            validationMethod(addressRefSender, 'address_validation_Sender', t("error.t13"))
        } else if (!selector?.multi_sender?.services) {
            validationMethod(servicesRefSender, 'service_validation_Sender', t("singleOrder.serviceType.t15"))
        } else if (!selector?.multi_sender?.first_name) {
            validationMethod(firstNameRefSender, 'firstName_validation_Sender', t("error.t4"))
        } else if (!selector?.multi_sender?.last_name) {
            validationMethod(lastNameRefSender, 'lastName_validation_Sender', t("error.t5"))
        }
            // else if(!selector?.multi_sender?.postal_code){
            //   validationMethod(postalCodeRefSender, 'postalCode_validation_Sender', 'وارد کردن کد پستی الزامی میباشد')
        // }
        else if (selector?.multi_sender?.postal_code && !checkNonZeroPrefix(selector?.multi_sender?.postal_code)) {
            validationMethod(postalCodeRefSender, 'postalCode_validation_Sender', t("error.t14"))
        } else if (!selector?.multi_sender?.mobile_number) {
            validationMethod(mobileRefSender, 'mobileNumber_validation_Sender', t("error.t6"))
        } else if (selector?.multi_sender?.mobile_number?.length !== 11 || !selector?.multi_sender?.mobile_number.startsWith("09")) {
            validationMethod(mobileRefSender, 'mobileNumber_validation_Sender', t("error.t7"))
        } else if (selector?.multi_info_box?.excelList?.length <= 0 && !selector?.single_info_box?.payment_type) {
            validationMethod(paymentRefMethods, 'payment_type_validation_BoxInfo', t("error.t27"))
        } else if (selector?.multi_info_box?.excelList?.length > 0 && selector?.multi_info_box?.excelList?.filter(e => e[4] === null)?.length > 0) {
            showMessageComponent(t("error.t59"), 'error')
            // validationMethod(paymentRefMethods, 'payment_type_validation_BoxInfo', t("error.t59"))
        } else if(!selector?.multi_sender?.need && !selector?.multi_sender?.selectedServicesFromMap?.id){
            showMessageComponent(t("singleOrder.serviceType.t26"), 'error')
        }
        else {
            nextStep()
        }
    }

    const validationsInfoBox = () => {
        if (!validate) {
            window.scrollTo(0, 0)
            selector?.multi_info_box?.list?.map((item, index) => {
                if (!item?.GoodsType) {
                    showMessageComponent(` محتوای مرسوله در مرسوله${index + 1}نباید خالی باشد `, 'error')
                } else if (!item?.ApproximateValue) {
                    showMessageComponent(` ارزش ریالی مرسوله در مرسوله ${index + 1}نباید خالی باشد `, 'error')
                } else if (!item?.CartonSizeName) {
                    showMessageComponent(`اندازه بسته در مرسوله ${index + 1} نباید خالی باشد`, 'error')
                }
                else if (item?.CartonSizeName === 'سایر(بزرگتر از کارتن سایز 9)' && item?.width > 100) {
                    showMessageComponent(`عرض بسته در مرسوله ${index + 1} باید بیشتر از 45 سانتی متر باشد`, 'error')
                } else if (item?.CartonSizeName === 'سایر(بزرگتر از کارتن سایز 9)' && item?.height > 100) {
                    showMessageComponent(`ارتفاع بسته در مرسوله ${index + 1} باید بیشتر از 35 سانتی متر باشد`, 'error')
                } else if (item?.CartonSizeName === 'سایر(بزرگتر از کارتن سایز 9)' && item?.length > 150) {
                    showMessageComponent(`طول بسته در مرسوله ${index + 1} باید بیشتر از 55 سانتی متر باشد`, 'error')
                }
                else if (!item?.Weight) {
                    showMessageComponent(`وزن مرسوله در مرسوله ${index + 1} نباید خالی باشد`, 'error')
                } else if (Number(item?.Weight?.split(',').join('')) < 50) {
                    showMessageComponent(`وزن مرسوله در مرسوله ${index + 1} نباید کمتراز 50 گرم باشد`, 'error')
                } else if (Number(item?.Weight?.split(',').join('')) > 50000) {
                    showMessageComponent(`وزن مرسوله در مرسوله ${index + 1} نباید بیشتراز 50,000 گرم باشد`, 'error')
                } else if (item?.CartonSizeName.includes('A') && Number(item?.Weight?.split(',').join('')) > 2000) {
                    showMessageComponent(`وزن مرسوله در پاکت پستی در مرسوله ${index + 1} نباید بیشتراز 2,000 گرم باشد`, 'error')
                } else if (selector?.multi_sender?.services == "723" && Number(item?.Weight?.split(',').join('')) > 30000) {
                    showMessageComponent(`وزن مرسوله در سرویس پست در مرسوله ${index + 1} نباید بیشتراز 30,000 گرم باشد`, 'error')
                } else if (!item?.Reciver_FristName) {
                    showMessageComponent(`نام گیرنده در مرسوله ${index + 1} نباید خالی باشد`, 'error')
                } else if (!item?.Reciver_LastName) {
                    showMessageComponent(`نام خانوادگی گیرنده در مرسوله ${index + 1} نباید خالی باشد`, 'error')
                } else if (!item?.Reciver_mobile) {
                    showMessageComponent(`شماره تلفن گیرنده در مرسوله ${index + 1} نباید خالی باشد`, 'error')
                } else if (!item?.Reciver_Address) {
                    showMessageComponent(`آدرس گیرنده در مرسوله ${index + 1} نباید خالی باشد`, 'error')
                } else if (item?.Reciver_Address?.length > 180) {
                    showMessageComponent(`آدرس گیرنده در مرسوله ${index + 1} نباید بیشتر از 180 کارکتر باشد`, 'error')
                } else if (selector?.multi_sender?.services == "740" && (!item?.ReciverLat || !item?.ReciverLon)) {
                    showMessageComponent(`آدرس گیرنده در مرسوله ${index + 1} شما فاقد موقعیت مکانی میباشد - لطفا موقعیت مکانی آدرس را ثبت کنید `, 'error')
                }
                // else if (!item?.Reciver_PostCode) {
                //     showMessageComponent(`کد پستی گیرنده در مرسوله ${index + 1} نباید خالی باشد`, 'error')
                // }
                else if (item?.Reciver_PostCode && !checkNonZeroPrefix(item?.Reciver_PostCode)) {
                    showMessageComponent(`کد پستی گیرنده در مرسوله ${index + 1} نامعتبر میباشد`, 'error')
                } else {
                    setValidate(true)
                }
            })
        } else {
            submitMultiOrder()
        }
    }

    const validationMethod = (ref, key, message) => {
        setValidationShow({[key]: message})
        handleScrollIntoView(ref)
        showMessageComponent(message, 'error')
    }

    const submitMultiOrder = async () => {
        dispatch(setLoading(true))
        let list = handleRemoveCommas()
        let fetch = await fetchData('', 'POST', '/checkout/bulkOrder',
            list,
            "application/json", '', '', ''
        )
        if (fetch?.success) {
            enqueueSnackbar('ثبت سفارش با موفقیت انجام شد', {
                variant: 'success',
                TransitionProps: {
                    direction: 'down',
                },
                anchorOrigin: {
                    horizontal: 'center',
                    vertical: 'top'
                }
            })
            setStep(2)
            // dispatch(setListBox([]))
            // dispatch(setExcelListBox([]))
        } else if (fetch && fetch?.status == 500) {
            navigate({
                pathname: "/pageInternalServer",
                search: location?.search
            });
        } else {
            fetch?.message && enqueueSnackbar(fetch?.message, {
                variant: 'error',
                TransitionProps: {
                    direction: 'down',
                },
                anchorOrigin: {
                    horizontal: 'center',
                    vertical: 'top'
                }
            })
        }

        setItems_Invoices(fetch)
        dispatch(setLoading(false))
    }

    const handleRemoveCommas = () => {
        let list = [...selector?.multi_info_box?.list]
        let update = list?.map(item => {
            return {
                ...item,
                ApproximateValue: Number(item?.ApproximateValue?.split(',')?.join('') || item?.ApproximateValue),
                Weight: Number(item?.Weight?.split(',')?.join('') || item?.Weight)
            }
        })
        return update
    }


    const handlerAddForm = () => {
        dispatch(setListBox([...selector?.multi_info_box?.list, {
            "ServiceID": Number(selector?.multi_sender?.services),
            "CodGoodsPrice": selector?.single_info_box?.payment_type === 'cod' ? Number(String(selector?.multi_info_box?.price)?.split(',').join('')) : 0,
            "divarToken": divarIncomId || 0,
            "InsuranceName": "* انتخاب بیمه ضروری است *",
            "Sender_FristName": selector?.multi_sender?.first_name,
            "Sender_LastName": selector?.multi_sender?.last_name,
            "Sender_mobile": selector?.multi_sender?.mobile_number,
            "Sender_StateId": String(selector?.multi_sender?.state_id),
            "Sender_City": selector?.multi_sender?.city_name,
            "Sender_townId": String(selector?.multi_sender?.city_id),
            "Sender_PostCode": '',
            "Sender_Address": selector?.multi_sender?.address,
            "Sender_Email": selector?.multi_sender?.email,
            "SenderLat": String(selector?.multi_sender?.lat),
            "SenderLon": String(selector?.multi_sender?.lng),
            "NeedCollector": selector?.multi_sender?.need,

            "Reciver_FristName": '',
            "Reciver_LastName": '',
            "Reciver_mobile": '',
            "Reciver_StateId": '',
            "Reciver_City": '',
            "Reciver_townId": '',
            "Reciver_stateName": "",
            "Reciver_townName": "",
            "Reciver_PostCode": '',
            "Reciver_Address": '',
            "Reciver_Email": '',
            "ReciverLat": '',
            "ReciverLon": '',
            "NeedDistributer": true,

            "CartonSizeName": '',
            "GoodsType": '',
            "ApproximateValue": '',
            "Weight": '',
            "length": '',
            "width": '',
            "height": '',

            "IsCOD": selector?.single_info_box?.payment_type === 'cod' || selector?.single_info_box?.payment_type === 'pass',
            "IsFreePost": selector?.single_info_box?.payment_type === 'free',
            "IsSafeBuy": selector?.single_info_box?.payment_type === 'amnito',
            "HasAccessToPrinter": selector?.multi_sender?.need ? false : !selector?.multi_sender?.factor,
            "AgentSaleAmount": Number(selector?.multi_info_box?.agent_services?.split(',').join('')) || 0,
            "discountCouponCode": discountCode,

            "selectedOfficeAddress": !selector?.multi_sender?.need ? (selector?.multi_sender?.selectedServicesFromMap?.shopId ? "1" : "2") + "=" + String(selector?.multi_sender?.selectedServicesFromMap?.id) : '',

            "boxType": 1,
            "Count": 1,
            "printLogo": selector?.multi_sender?.trademark,
            // "notifBySms": selector?.multi_sender?.notification,
            "notifBySms": true,
            "orderSource": process.env.REACT_APP_SITE === 'amnito' ? 24 : ((localStorage.getItem('token-id') && localStorage.getItem('token-id') != 'null') ? 21 : 22),
            "refrenceNo": "",
            "IsBreakable": selector?.multi_sender?.breakable,
            "IsLiquid": selector?.multi_sender?.liquid,
            "NeedCarton": selector?.multi_sender?.need,
            "affiliateName": sessionStorage.getItem('affiliate'),
            "shipmentTempId": Number(selector?.multi_sender?.services),
            "CustomerDesc": "",
            "CustomerOrderNo": "213",
            "paymentType": selector?.single_info_box?.payment_type,
        }]))
        setStep(1)
        // handleUpdateDiscountCode(discountCode)
    }

    const splitSize = (e) => {
        if (e) {
            return e.split('(')[1].split(')')[0].split('*')
        }
    }

    const handlerAddFormWithExcel = () => {
        let items = []
        selector?.multi_info_box?.excelList?.slice(1)?.map(i => {
            items.push(
                {
                    "ServiceID": Number(selector?.multi_sender?.services),
                    "CodGoodsPrice": i[5] == 'پرداخت در محل (COD)' ? Number(String(i[3])?.split(',').join('')) : 0,
                    "divarToken": (divarIncomId && divarIncomId != 'null') || 0,
                    "InsuranceName": i[4]?.length > 0 ? i[4] :  "* انتخاب بیمه ضروری است *",
                    "Sender_FristName": selector?.multi_sender?.first_name,
                    "Sender_LastName": selector?.multi_sender?.last_name,
                    "Sender_mobile": selector?.multi_sender?.mobile_number,
                    "Sender_StateId": String(selector?.multi_sender?.state_id),
                    "Sender_City": selector?.multi_sender?.city_name,
                    "Sender_townId": String(selector?.multi_sender?.city_id),
                    "Sender_PostCode": '',
                    "Sender_Address": selector?.multi_sender?.address,
                    "Sender_Email": selector?.multi_sender?.email,
                    "SenderLat": String(selector?.multi_sender?.lat),
                    "SenderLon": String(selector?.multi_sender?.lng),
                    "NeedCollector": selector?.multi_sender?.need,

                    "Reciver_FristName": i[10],
                    "Reciver_LastName": i[11],
                    "Reciver_mobile": i[12],
                    "Reciver_StateId": '',
                    "Reciver_City": i[14],
                    "Reciver_state": i[13],
                    "Reciver_townName": i[14],
                    "Reciver_stateName": i[13],
                    "Reciver_townId": '',
                    "Reciver_PostCode": String(i[15]),
                    // "Reciver_Address": i['آدرس گیرنده *'],
                    "Reciver_Address": i[16] || '',
                    "Reciver_Email": i[17] || '',
                    "ReciverLat": '',
                    "ReciverLon": '',
                    "NeedDistributer": true,

                    "CartonSizeName": i[6],
                    "GoodsType": i[2],
                    "ApproximateValue": String(i[3]),
                    "Weight": String(i[0]),
                    "length": i[6] == 'سایر(بزرگتر از کارتن سایز 9)' ? i[7] : Number(splitSize(i[6])[0] || 5),
                    "width": i[6] == 'سایر(بزرگتر از کارتن سایز 9)' ? i[8] : Number(splitSize(i[6])[1] || 5),
                    "height": i[6] == 'سایر(بزرگتر از کارتن سایز 9)' ? i[9] : Number(splitSize(i[6])[2] || 5),
                    "IsCOD": i[5] == 'پرداخت در محل (COD)' || i[5] == 'پس‌کرایه',
                    "IsFreePost": i[5] == 'ارسال رایگان',
                    "IsSafeBuy": i[5] == 'خرید و فروش امن ( امنیتو )',
                    "HasAccessToPrinter": i[1] !== 'دارم' || selector?.multi_sender?.factor,
                    "AgentSaleAmount": Number(i[18]) || 0,
                    "discountCouponCode": discountCode,

                    "boxType": 1,
                    "Count": 1,
                    "printLogo": selector?.multi_sender?.trademark,
                    // "notifBySms": selector?.multi_sender?.notification,
                    "notifBySms": true,
                    "orderSource": process.env.REACT_APP_SITE === 'amnito' ? 24 : ((localStorage.getItem('token-id') && localStorage.getItem('token-id') != 'null') ? 21 : 2),
                    "refrenceNo": "",
                    "IsBreakable": i[19] === 'بلی',
                    "IsLiquid": i[20] === 'بلی',
                    "NeedCarton": i[1] !== 'دارم',

                    "affiliateName": sessionStorage.getItem('affiliate'),
                    "selectedOfficeAddress": !selector?.multi_sender?.need ? (selector?.multi_sender?.selectedServicesFromMap?.shopId ? "1" : "2") + "=" + String(selector?.multi_sender?.selectedServicesFromMap?.id) : '',
                    "shipmentTempId": Number(selector?.multi_sender?.services),
                    "CustomerDesc": "",
                    "CustomerOrderNo": "213",
                    "paymentType": handleSetPaymentType(i[5]) ,
                }
            )
        })
        dispatch(setListBox(items))
        setStep(1)
    }

    const handleSetPaymentType = (item) => {
        switch (item){
            case "آنلاین":
            case "انلاین":
            case "پیشکرایه":
                return "online"
            case "خرید و فروش امن ( امنیتو )":
                return "amnito"
            case "پرداخت در محل (COD)":
                return "cod"
            case "ارسال رایگان":
                return "free"
            case "پس‌کرایه":
                return "pass"
            default:
                return "online"
        }
    }

    const payOrder = async () => {
        dispatch(setLoading(true))
        let fetch = await fetchData('', 'POST', '/payment', {
                "orderId": Number(items_Invoices?.orderId),
                "paymentmethod": paymentMethod === "Payments.Wallet" ? "" : paymentMethod,
                "useRewardPoints": paymentMethod === "Payments.Wallet",
                "isForeign": false,
                "reciverPay": false,
                "DivarToken": divarIncomId || null,
                "callBackUrl": `https://${process.env.REACT_APP_SUBDOMAIN}.postex.ir/paymentStatus`
            },
            "application/json", '', '', ''
        )
        if (fetch?.IsSuccess) {
            if (paymentMethod === "Payments.Wallet") {
                navigate({
                    pathname: "/paymentStatus",
                    search: createSearchParams({
                        OrderId: fetch?.Data?.orderId,
                        code: 0,
                        state: fetch?.Data?.divarToken
                    }).toString()
                });
                enqueueSnackbar(fetch?.Message, {
                    variant: 'success',
                    TransitionProps: {
                        direction: 'down',
                    },
                    anchorOrigin: {
                        horizontal: 'center',
                        vertical: 'top'
                    }
                })
            } else {
                window.open(fetch?.Data, '_self')
            }
        } else if (fetch && fetch?.StatusCode == 500) {
            navigate({
                pathname: "/pageInternalServer",
                search: location?.search
            });
        } else {
            enqueueSnackbar(fetch?.Message, {
                variant: 'error',
                TransitionProps: {
                    direction: 'down',
                },
                anchorOrigin: {
                    horizontal: 'center',
                    vertical: 'top'
                }
            })
        }
        dispatch(setLoading(false))
    }


    const handleUpdateDiscountCode = (e) => {
        let list = [...selector?.multi_info_box?.list]
        list.map(i => {
            i.discountCouponCode = e
        })
        dispatch(setListBox(list))
    }


    return (
        <>
            <NavBar blue/>
            <div className="container">
                <div className="multiOrderPage desktopSection bgDesktopPage">

                    {step === 0 && <Sender
                        servicesRefSender={servicesRefSender}
                        firstNameRefSender={firstNameRefSender}
                        lastNameRefSender={lastNameRefSender}
                        mobileRefSender={mobileRefSender}
                        postalCodeRefSender={postalCodeRefSender}
                        addressRefSender={addressRefSender}
                        address1RefSender={address1RefSender}
                        paymentRefMethods={paymentRefMethods}

                        validation={validationShow}
                    />}
                    {step === 1 && <InfoBox
                        discountCode={discountCode}
                        handleDiscountCode={(event) => {
                            handleUpdateDiscountCode(event)
                            setDiscountCode(event)
                        }}
                        handlerAddForm={() => handlerAddForm()}
                    />}

                    {step === 2 && <Invoice
                        handlePaymentMethod={(event) => setPaymentMethod(event)}
                        items={items_Invoices}
                        paymentMethod={paymentMethod}
                    />}


                    <div className="btnGroup_blue">
                        {step === 1 && <button className="btnEmpty" onClick={() => preStep()} id="preStep1">
                            <KeyboardArrowRight fontSize="large"/>
                            <span>{t("multiOrder.t1")}</span>
                        </button>
                        }
                        {step === 2 && <button className="btnEmpty" onClick={() => cancelStep()} id="cancelStep">
                            <Close fontSize="large"/>
                            <span>{t("singleOrder.t5")}</span>
                        </button>
                        }
                        {step === 0 && <button className="btnFill btn-effect" onClick={() => validationsInfoSender()}
                                               id="validationsInfoSender">
                            <span>{t("multiOrder.t2")}</span>
                            <KeyboardArrowLeft fontSize="medium"/>
                        </button>}
                        {step === 1 && <button className="btnFill btn-effect" disabled={selector?.loading?.isLoading}
                                               onClick={() => validationsInfoBox()} id="validationsInfoBox">
                            {
                                selector?.loading?.isLoading ?
                                    <Box sx={{display: 'flex'}}>
                                        <CircularProgress size={20}/>
                                    </Box>
                                    :
                                    <>
                                        <span>{t("multiOrder.t3")}</span>
                                        <KeyboardArrowLeft fontSize="medium"/>
                                    </>
                            }
                        </button>}

                        {step === 2 && <button className="btnFill btn-effect" disabled={selector?.loading?.isLoading}
                                               onClick={payOrder} id="payOrder">
                            {
                                selector?.loading?.isLoading ?
                                    <Box sx={{display: 'flex'}}>
                                        <CircularProgress size={20}/>
                                    </Box>
                                    :
                                    <>
                                        <span>{t("singleOrder.t4")}</span>
                                        <Payment fontSize="medium"/>
                                    </>
                            }
                        </button>}


                    </div>
                </div>
            </div>

        </>
    )
}
